import { media, styled } from '@styles';

import breadcrumbsArrow from 'images/breadcrumbs-arrow.svg';

export const Wrapper = styled.div``;

export const Breadcrumbs = styled.ul`
  display: inline-flex;
  flex-wrap: wrap;
  margin: 24px 62px;
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  ${media.largeScreen`
    margin: 21px 62px;
  `}
  ${media.mediumScreen`
    margin: 20px 31px;
  `}
  ${media.smallScreen`
    margin: 10px 16px;
  `}
`;

export const Item = styled.li<{ active: boolean }>`
  text-transform: capitalize;
  opacity: ${(props) => (props.active ? 1 : 0.5)};
  transition: opacity 0.25s ease-in-out;

  &:not(:last-of-type) {
    &:after {
      content: url(${breadcrumbsArrow});
      display: inline-block;
      margin: 0 calc(${(props) => props.theme.spacing.spacer} / 2);
    }
  }

  a {
    color: ${(props) => props.theme.colors.lightFont};
    font-weight: ${(props) =>
      props.active ? props.theme.typography.boldFontWeight : undefined};
    text-decoration: none;
    vertical-align: middle;
    transition: 0.3s;
    font-size: ${(props) => props.theme.typography.smallFontSize};

    &:hover,
    &:focus {
      opacity: 1;
      color: ${(props) => props.theme.colors.red};
    }
  }
`;
